const getMemoriamPath = (id: string) => {
  return `/in-memoriam/${id}`;
};

export default getMemoriamPath;
